export default __webpack_public_path__ + "static/media/metrics.a6cfbdba.svg";